// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";


console.log("process.env", process.env)
// initialize an empty api service that we'll inject endpoints into later as needed
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.GATSBY_API_BASE_URL,
  mode: "cors",
  prepareHeaders: (headers) => {
    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }

    return headers;
  },
});

const baseQueryWithHook: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  // wait until the mutex is available without locking it
  if (api.endpoint === "refetch") {
    return { data: true };
  }
  const result = await baseQuery(args, api, extraOptions);
  return result;
};

export const shoeApi = createApi({
  baseQuery: baseQueryWithHook,
  endpoints: () => ({}),
});
